import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import Support from "../components/Support";
import { SITE } from "../data/siteData";

export default function UnlockPage() {
  const { currentUser, unlockWithCode, hasFullAccess } = useAuth();
  const navigate = useNavigate();
  const [code, setCode] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);

  if (!currentUser) {
    return (
      <div style={centered}>
        <p style={{ color: "#64748b", marginBottom: 16 }}>
          You need to be logged in to activate an access code.
        </p>
        <button onClick={() => navigate("/auth")} style={btnPrimary}>
          Sign in or create account
        </button>
      </div>
    );
  }

  if (hasFullAccess || success) {
    return (
      <div style={centered}>
        <div style={{ fontSize: 48, marginBottom: 12 }}>🎉</div>
        <h2 style={{ color: "#16a34a", fontWeight: 800, marginBottom: 8 }}>
          Course unlocked!
        </h2>
        <p style={{ color: "#64748b", marginBottom: 20 }}>
          Welcome, {currentUser.name}. All lessons are now available.
        </p>
        <button onClick={() => navigate("/course")} style={btnPrimary}>
          Go to my course →
        </button>
      </div>
    );
  }

  const handleActivate = async () => {
    setError("");
    if (!code.trim()) {
      setError("Please enter your access code.");
      return;
    }
    setLoading(true);
    const result = await unlockWithCode(code);
    setLoading(false);
    if (!result.ok) {
      setError(result.error);
      return;
    }
    setSuccess(true);
  };

  return (
    <div
      style={{
        minHeight: "100vh",
        background: "#f0f9ff",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: 16,
      }}
    >
      <div style={{ width: "100%", maxWidth: 420 }}>
        <div style={{ textAlign: "center", marginBottom: 24 }}>
          <span style={{ fontWeight: 900, fontSize: 24, color: "#0ea5e9" }}>
            {SITE.name}
          </span>
          <p style={{ color: "#64748b", fontSize: 14, marginTop: 6 }}>
            Activate your access code
          </p>
        </div>

        <div
          style={{
            background: "#fff",
            border: "1px solid #e2e8f0",
            borderRadius: 10,
            padding: "28px 24px",
            boxShadow: "0 2px 12px rgba(0,0,0,0.06)",
          }}
        >
          <p
            style={{
              color: "#475569",
              fontSize: 13,
              lineHeight: 1.8,
              marginBottom: 20,
            }}
          >
            Enter the access code that was sent to you after payment. Your code
            is linked to{" "}
            <strong style={{ color: "#0ea5e9" }}>{currentUser.email}</strong>{" "}
            and will only activate on this account.
          </p>

          <p style={{ fontSize: 12, color: "#94a3b8", marginBottom: 8 }}>
            Format:{" "}
            <span
              style={{
                fontFamily: "monospace",
                color: "#475569",
                fontWeight: 600,
              }}
            >
              SKL-XXXXXX
            </span>
          </p>

          <input
            value={code}
            onChange={(e) => {
              setCode(e.target.value.toUpperCase());
              setError("");
            }}
            placeholder="SKL-XXXXXX"
            onKeyDown={(e) => e.key === "Enter" && handleActivate()}
            style={{
              width: "100%",
              padding: "11px 12px",
              border: "1px solid #d1d5db",
              borderRadius: 6,
              fontSize: 16,
              fontFamily: "monospace",
              fontWeight: 700,
              letterSpacing: 2,
              color: "#1e293b",
              outline: "none",
              marginBottom: 4,
              boxSizing: "border-box",
            }}
          />

          {error && (
            <div
              style={{
                background: "#fef2f2",
                border: "1px solid #fecaca",
                borderRadius: 6,
                padding: "10px 12px",
                margin: "12px 0",
              }}
            >
              <p style={{ color: "#dc2626", fontSize: 13, margin: 0 }}>
                {error}
              </p>
            </div>
          )}

          <button
            onClick={handleActivate}
            disabled={loading}
            style={{
              width: "100%",
              padding: "11px 0",
              marginTop: 14,
              background: loading ? "#94a3b8" : "#0ea5e9",
              border: "none",
              borderRadius: 6,
              color: "#fff",
              fontSize: 14,
              fontWeight: 700,
              cursor: loading ? "not-allowed" : "pointer",
            }}
          >
            {loading ? "Checking..." : "Activate code →"}
          </button>
        </div>

        <Support style={{ marginTop: 20 }} />
      </div>
    </div>
  );
}

const centered = {
  minHeight: "60vh",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  padding: 24,
  textAlign: "center",
};

const btnPrimary = {
  padding: "10px 28px",
  background: "#0ea5e9",
  border: "none",
  borderRadius: 6,
  color: "#fff",
  fontSize: 14,
  fontWeight: 700,
  cursor: "pointer",
};
